import type { TagColor } from '@atlaskit/tag';

import { DEFAULT_PLUGIN_TAG_COLOR, PLUGIN_TAG_COLOR } from './constants';
import type { PluginName } from './types';

/**
 * Gets the tag color for a plugin name.
 * Returns the mapped color if known, otherwise returns the default.
 */
export const getPluginTagColor = (pluginName: string | undefined): TagColor => {
	if (!pluginName) {
		return DEFAULT_PLUGIN_TAG_COLOR;
	}
	if (pluginName in PLUGIN_TAG_COLOR) {
		return PLUGIN_TAG_COLOR[pluginName as PluginName];
	}
	return DEFAULT_PLUGIN_TAG_COLOR;
};
